import TagItemsGridComponent from "./tag-items-grid-component";
import TagItemsGridConfig from "./tag-items-grid-config";
import TagItemsGridAdvancedConfig from "./tag-items-grid-advanced-config";

export default {
  TagItemsGridComponent,
  TagItemsGridConfig,
  TagItemsGridAdvancedConfig
};
